import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43296 30162"
    {...props}
  >
    <path
      d="M30875 23202c-789 196-1564 396-2343 575-191 44-396 30-596 30-4074 1-8149 0-12224 0h-434c-191 819-294 1613-562 2348-1003 2764-3833 4362-6834 3914-2729-407-4947-2822-5142-5633-31-448-119-711-603-892-972-365-1492-1295-1418-2391 99-1466 224-2931 354-4395 25-279 23-507-264-655-104-53-182-162-259-257-1068-1322-508-3531 1050-4181 127-53 217-198 319-304 387-406 778-809 1153-1226 109-121 233-283 240-432 71-1600 1091-2588 2729-2590 4458-5 8915-2 13373-2 77 0 153 0 230 4 1350 82 2278 925 2454 2229 159 1177-554 2217-1789 2660-147 53-299 248-344 406-441 1570-353 3152-68 4733 89 496 195 990 329 1477 35 128 186 293 307 318 2286 454 4589 792 6926 728 649-18 1309-148 1935-329 863-251 1116-669 1132-1555 24-1397-296-2745-706-4055-927-2960-1935-5895-2908-8841-104-318-204-639-285-963-155-615-652-943-1283-890-472 40-952 45-1423 2-717-67-1266-673-1311-1380-47-746 406-1439 1144-1551 596-91 1281-186 1811 19 1036 401 2031 950 2967 1553 694 448 925 1236 1096 2045 143 675 455 1317 717 1962 38 93 215 156 339 181 580 120 988 448 1268 962 1479 2714 2965 5424 4435 8143 151 279 335 420 641 506 1839 515 3246 1535 3923 3403 73 203 238 388 399 540 1888 1784 2472 4588 1444 6968-1032 2389-3473 3911-6044 3766-3447-195-6043-3088-5876-6547 8-163 1-325 1-403zm6511-2506c0-19-2-37-2-55-671 48-1343 79-2011 155-227 26-480 116-656 259-1675 1346-1830 3766-363 5421 1341 1511 3793 1573 5309 135 1509-1433 1514-3886 14-5345-383-373-791-658-1375-578-299 42-610 8-916 8zm-24737 3152H5224c-98 1908 1426 3790 3675 3809 2079 19 3746-1618 3750-3809z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
